/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: RootLoader.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 111
 * ---
 * Description:
 */

import React               from 'react';
import { useSelector }     from 'react-redux';
import { RootState }       from '../../../store';
import { Intent, Spinner } from '@blueprintjs/core';
import { LoadingStatuses } from '../../../store/slices/loading-slice';

export const RootLoader = (props: { children?: any }) => {
  const loading = useSelector((state: RootState) => state.loadingState);
  if (loading.root && loading.status === LoadingStatuses.RUNNING)
    return (
      <div className="mle-center-both-axes-parent">
        <div
          className="mle-center-both-axes-child w-96 bg-white bg-opacity-10 rounded-sm pt-4">
          <Spinner size={ 60 } intent={ Intent.PRIMARY }/>
          <p className="text-center bp4-text-muted mt-3 mb-2">
            Caricamento in corso...
          </p>
        </div>
      </div>
    );
  return props.children;
};


